import { wrapper } from "../../redux";
import { addBreadcrumb } from "../../redux/action-creaters/breadcrumbs";
import { fetchQuestions } from "../../redux/action-creaters/content";
import Faq from "/components/pages/faq";
import Redis from "/lib/redis";
import { Api } from "/api";
import pagesWrapper from "/pagesSrrLogic/pagesWrapper";
import { SITE_PAGE_TYPE } from "/pagesSrrLogic/sitePageType";
import { sspWrapper } from "../../utils/errors/sspWrapper";

export default function FaqPage({
  scripts,
  host,
  videos,
  isBaltex,
  isLanding,
}) {
  return (
    <Faq
      scripts={scripts}
      host={host}
      videos={videos}
      isBaltex={isBaltex}
      isLanding={isLanding}
    />
  );
}

export const getServerSideProps = wrapper.getServerSideProps((store) =>
  sspWrapper(async ({ req, query, resolvedUrl }) => {
    await store.dispatch(await fetchQuestions(Redis, Boolean(query.reset)));

    const videos = await Api.content.getPromoVideos(
      Redis,
      Boolean(query.reset),
    );

    store.dispatch(addBreadcrumb({ link: "/faq/", name: "Вопросы и ответы" }));

    return pagesWrapper(
      {
        pageType: SITE_PAGE_TYPE.static,
        videos,
      },
      store,
      Redis,
      {
        query,
        req,
        resolvedUrl,
      },
      "/faq/",
    );
  }),
);
